module.exports = __webpack_public_path__ + "img/09.d5159862.jpg";